import React from 'react';

import { useSelector } from 'react-redux';
import { getPercentileInfo, isUsingFourCategories } from '../../util/cutscores';

export default function ClassProgressCellGroup(props) {
  const {season, isBenchmarkOnly} = props;
  const {score, latestScore, PR} = season;

  const selectedStatePercentileCuts = useSelector(state => state.reports.teacher.selectedStatePercentileCuts);

  const cellStyle = {};
  const percentileInfo = getPercentileInfo(PR, selectedStatePercentileCuts);
  cellStyle.backgroundColor = percentileInfo.color;
  if (!PR && PR !== 0) cellStyle.backgroundColor = '#f9f6f2';
  else cellStyle.color = "white";

  return (
    <div className="classProgressCellGroup">
      <div className="classProgressCellData" style={cellStyle}>{score ?? " "}</div>
      <div className="classProgressCellData" style={cellStyle}>{PR ?? " "}</div>
      {!isBenchmarkOnly && <div className="classProgressCellData classProgressDefaultBg">{latestScore ?? " "}</div>}
    </div>
  );
}
